import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { usePmCode } from 'hooks';
import { selectBoxFilterOption } from 'utils/form-utils';

export interface PmSelectBox {
  codeValue?: number|undefined;
  boxSize?: string;
  onChangeSelect?: (value: string | number) => void;
}

const PmCode = ({
  codeValue,
  boxSize = '150px',
  onChangeSelect
}: PmSelectBox): React.ReactElement => {
    
  /* ======================================================
  * States
  * ====================================================== */
  const [options, setOptions] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState<string>('');


  /* ======================================================
  * hooks
  * ====================================================== */
  const { pmCodeList } = usePmCode({});  

  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    const opts : any[] = [];
    opts.push({value: 'A', label: '전체'})

    if (pmCodeList) {
      pmCodeList.forEach((item) => {
        if (searchValue.length > 0) {
          opts.push({value: item.value, label: item.label})  
        } else if (item.loginYn == 'Y') {
          opts.push({value: item.value, label: item.label})  
        }
      })
    }

    setOptions(opts);
    
  }, [pmCodeList, searchValue]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Select 
      style={{width:boxSize }} 
      value={codeValue}
      placeholder={'PM'}
      onSelect={onChangeSelect}
      virtual={false}
      showSearch={true} 
      options={options}       
      optionFilterProp="label"     
      filterOption={selectBoxFilterOption}
      searchValue={searchValue}
      onSearch={(value)=>setSearchValue(value)}
    /> 
  );
};

export default PmCode;
